export enum BreakingChangeType {
  branchingEnabled = 'branchingEnabled',
  duplicateIdsFixed = 'duplicateIdsFixed',
  omniChannelEnabled = 'omniChannelEnabled'
}

export type DesignMetaDataBreakingChange = {
  message: string;
  timestamp: number;
  type: BreakingChangeType;
};
